export function InstagramIcon() {
  return (
    <svg width='24' height='24' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z'
        fill='url(#paint0_linear_96_3903)'
      />
      <path
        d='M16 19.2727C17.8075 19.2727 19.2727 17.8075 19.2727 16C19.2727 14.1925 17.8075 12.7273 16 12.7273C14.1925 12.7273 12.7273 14.1925 12.7273 16C12.7273 17.8075 14.1925 19.2727 16 19.2727Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M24.9457 19.7105C24.9022 20.6686 24.7498 21.3227 24.5274 21.8952C24.0599 23.1042 23.1042 24.0599 21.8952 24.5274C21.3229 24.7498 20.6686 24.9019 19.7108 24.9457C18.751 24.9895 18.4444 25 16.0002 25C13.5558 25 13.2494 24.9895 12.2895 24.9457C11.3316 24.9019 10.6773 24.7498 10.105 24.5274C9.50423 24.3014 8.96038 23.9472 8.51076 23.4892C8.05301 23.0399 7.69882 22.4958 7.47282 21.8952C7.2504 21.3229 7.09805 20.6686 7.05453 19.7108C7.01028 18.7508 7 18.4442 7 16C7 13.5558 7.01028 13.2492 7.05429 12.2895C7.09782 11.3314 7.24992 10.6773 7.47234 10.1048C7.69834 9.50422 8.05277 8.96014 8.51076 8.51076C8.96014 8.05277 9.50423 7.69858 10.1048 7.47258C10.6773 7.25016 11.3314 7.09805 12.2895 7.05429C13.2492 7.01052 13.5558 7 16 7C18.4442 7 18.7508 7.01052 19.7105 7.05453C20.6686 7.09805 21.3227 7.25016 21.8952 7.47234C22.4958 7.69834 23.0399 8.05277 23.4895 8.51076C23.9472 8.96038 24.3017 9.50422 24.5274 10.1048C24.7501 10.6773 24.9022 11.3314 24.9459 12.2895C24.9897 13.2492 25 13.5558 25 16C25 18.4442 24.9897 18.7508 24.9457 19.7105ZM20.9091 16C20.9091 18.7112 18.7112 20.9091 16 20.9091C13.2888 20.9091 11.0909 18.7112 11.0909 16C11.0909 13.2888 13.2888 11.0909 16 11.0909C18.7112 11.0909 20.9091 13.2888 20.9091 16ZM22 11.2273C22 11.7545 21.5726 12.1818 21.0455 12.1818C20.5183 12.1818 20.0909 11.7545 20.0909 11.2273C20.0909 10.7001 20.5183 10.2727 21.0455 10.2727C21.5726 10.2727 22 10.7001 22 11.2273Z'
        fill='white'
      />
      <defs>
        <linearGradient
          id='paint0_linear_96_3903'
          x1='5.5'
          y1='1.42492e-07'
          x2='28.5'
          y2='36'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFC100' />
          <stop offset='0.305' stopColor='#FE0098' />
          <stop offset='0.705' stopColor='#FC01D6' />
          <stop offset='1' stopColor='#8B0AFA' />
        </linearGradient>
      </defs>
    </svg>
  )
}
